'use client'

import dynamic from 'next/dynamic'
import { useRef } from 'react'

import { useAccountMenu } from '../../hooks/useAccountMenu'
import { AccountIcon } from '../AccountIcon/AccountIcon'
import { WrapperAccountMenu } from '../WrapperAccountMenu/WrapperAccountMenu'

const AccountMenu = dynamic(() =>
	import('../AccountMenu/AccountMenu').then((mod) => mod.AccountMenu)
)

export const AccountActions = ({
	hasFavorites,
}: {
	readonly hasFavorites: boolean
}) => {
	const { isOpen } = useAccountMenu()
	const refAccountLink = useRef<HTMLAnchorElement>(null)
	const refAccountMenu = useRef<HTMLDivElement>(null)

	return (
		<>
			<AccountIcon
				refAccountMenu={refAccountMenu}
				refAccountLink={refAccountLink}
			/>
			<WrapperAccountMenu refAccountMenu={refAccountMenu}>
				{isOpen ? (
					<AccountMenu
						refAccountMenu={refAccountMenu}
						refAccountLink={refAccountLink}
						hasFavorites={hasFavorites}
					/>
				) : null}
			</WrapperAccountMenu>
		</>
	)
}
